<template>
  <div>
    <!-- 投保信息  -->
    <Form ref="form" :label-width="130" class="page-form detail" v-if="detailData">
      <div class="form-title">备注</div>
      <FormItem label="" :label-width="25">
        <span>{{ detailData.remark || '-' }}</span>
      </FormItem>
      <div class="form-title">基本信息</div>
      <FormItem label="订单号">
        <span>{{ detailData.insureUniqueId }}</span>
      </FormItem>
      <FormItem label="承保时间">
        <span>{{ detailData.insureTime && detailData.insureTime.substring(0, 16) }}</span>
      </FormItem>
      <FormItem label="保单号">
        <span>{{ detailData.policyNo }}</span>
      </FormItem>
      <FormItem label="投保单号">
        <span>{{ detailData.proposalNo }}</span>
      </FormItem>
      <FormItem label="产品名称">
        <span>{{ detailData.productName }}({{ detailData.productCode }})</span>
      </FormItem>
      <FormItem label="长短险标志">
        <span v-if="detailData.periodType == 1">长险</span>
        <span v-if="detailData.periodType == 2">短险</span>
      </FormItem>
      <FormItem label="归属业务员">
        <span>{{ detailData.salesmanName }}</span>
      </FormItem>
      <FormItem v-if="$units.isOkBao() || $units.isRYBB()" label="个险销售支持">
        <span>{{ detailData.saleSupportName || '-'}}</span>
      </FormItem>
      <FormItem label="所属团队">
        <span>{{ detailData.groupName }}</span>
      </FormItem>
      <FormItem label="所属机构">
        <span>{{ detailData.orgName }}</span>
      </FormItem>
      <FormItem label="保障期限">
        <span v-if="detailData.guaranteeType == 1">保终身</span>
        <span v-if="detailData.guaranteeType == 2">保{{ detailData.guaranteeLimit }}岁</span>
        <span v-if="detailData.guaranteeType == 3">保{{ detailData.guaranteeLimit }}年</span>
        <span v-if="detailData.guaranteeType == 4">保{{ detailData.guaranteeLimit }}个月</span>
        <span v-if="detailData.guaranteeType == 5">保{{ detailData.guaranteeLimit }}天</span>
      </FormItem>
      <FormItem label="起保日期">
        <span>{{ detailData.startTime }}</span>
      </FormItem>
      <FormItem label="终保日期">
        <span>{{ detailData.endTime }}</span>
      </FormItem>
      <FormItem label="回执回销状态">
        <lzDicTxt dicType="RECEIPT_STATUS" :dicCode="detailData.receiptStatus" v-if="detailData.receiptStatus"></lzDicTxt>
      </FormItem>
      <FormItem label="回执回销日期">
        <div>{{ detailData.receiptDate | filterTime('YYYY-MM-DD') }}</div>
      </FormItem>
      <FormItem label="回执签收日期">
        <div>{{ detailData.receiptDate2 | filterTime('YYYY-MM-DD') }}</div>
      </FormItem>
      <FormItem label="回访状态">
        <lzDicTxt dicType="VERIFY_STATUS" :dicCode="detailData.revisitStatus" v-if="detailData.revisitStatus"></lzDicTxt>
      </FormItem>
      <FormItem label="回访日期">
        <div>{{ detailData.revisitDate | filterTime('YYYY-MM-DD') }}</div>
      </FormItem>
      <FormItem label="犹豫期截止日">
        <span>{{ detailData.hesitateDate && detailData.hesitateDate.substring(0, 10) }}</span>
      </FormItem>
      <FormItem label="总保费">
        <span>{{ detailData.fee }}元</span>
      </FormItem>
      <FormItem label="公司标保">
        <span>{{ detailData.foldFyb }}元</span>
      </FormItem>
      <FormItem label="交费方式">
        <span>{{ detailData.payTypeDesc }}</span>
      </FormItem>
      <FormItem label="交费期">
        <span>{{ detailData.paymentDesc }}</span>
      </FormItem>
      <FormItem label="状态">
        <span>{{ detailData.policyStatus | filterInsureOrderStatus }}</span>
      </FormItem>
      <FormItem label="质检状态">
        <span v-if="detailData.confirmRightStatus === 0">待单录</span>
        <span v-else-if="detailData.confirmRightStatus === 1">待质检</span>
        <span v-else-if="detailData.confirmRightStatus === 2">质检成功</span>
        <span v-else-if="detailData.confirmRightStatus === -1">质检失败</span>
        <span v-else-if="!detailData.confirmRightStatus">-</span>
        <Poptip trigger="hover" transfer-class-name="my-poptip left0" :transfer="true">
          <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" v-if="detailData.confirmRightStatus === -1 && detailData.qualityFailReason" />
          <div slot="content">
            <p>{{ detailData.qualityFailReason }}</p>
          </div>
        </Poptip>
      </FormItem>
      <FormItem label="质检时间">
        <div>{{ detailData.qualityTime || '-' }}</div>
      </FormItem>
      <FormItem label="结算状态" v-if="formData.isGift != 1">
        <div v-if="detailData.settlementStatus == '0'">未结算</div>
        <div v-else-if="detailData.settlementStatus == '1'">已结算</div>
      </FormItem>
      <FormItem label="服务代理人">
        <span>{{ detailData.serviceAgentStaffNo || '-' }}/{{ detailData.serviceAgentName || '-' }}</span>
      </FormItem>
      <FormItem v-if="detailData.serviceEffectiveDate" label="服务生效日">
        <span>{{ detailData.serviceEffectiveDate.substring(0, 10) }}</span>
      </FormItem>
      <div class="form-title">服务代理人变更记录</div>
      <div class="tableBox">
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row, index }" slot="serviceAgent">
            <i class="dian" :class="{ 'red': row.workingState == 0, 'orange': row.isSus == 1 }"></i>
            <span>{{ row.staffNo ? row.userName + '/' + row.staffNo : row.userName }}</span>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <div class="detail">
              <div :class="{ 'disabled': row.status == 1 }" @click="row.status == 0 && deleteAgent(row)">
                <span>删除</span>
              </div>
            </div>
          </template>
        </Table>
        <Button style="margin: 10px 0" type="primary" @click="changeServiceAgent" class="btn-change">+变更服务代理人</Button>
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
      </div>
      <div class="form-title">投保人信息</div>
      <FormItem label="姓名">
        <span>{{ holderData.name }}</span>
      </FormItem>
      <FormItem label="性别">
        <span>{{ holderData.sex | filterSex }}</span>
      </FormItem>
      <FormItem label="证件类型">
        <span>{{ holderData.cardType | filterCardType }}</span>
      </FormItem>
      <FormItem label="证件号">
        <div>
          <span v-if="!holderData.eyeShow1">{{ holderData.cardNumber }}</span>
          <span v-else>{{ holderData.cardNumber1 }}</span>
          <span v-if="holderData.cardNumber">
            <i class="iconfont iconxianshi eye-icon" v-if="holderData.eyeShow1" @click="openEye(holderData, 'eyeShow1', 'cardNumber')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye(holderData, 'eyeShow1', 'cardNumber')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem label="手机号码">
        <div>
          <span v-if="!holderData.eyeShow2">{{ holderData.mobile }}</span>
          <span v-else>{{ holderData.mobile1 }}</span>
          <span v-if="holderData.mobile">
            <i class="iconfont iconxianshi eye-icon" v-if="holderData.eyeShow2" @click="openEye(holderData, 'eyeShow2', 'mobile')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye(holderData, 'eyeShow2', 'mobile')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem label="电子邮箱">
        <div>
          <span v-if="!holderData.eyeShow3">{{ holderData.email }}</span>
          <span v-else>{{ holderData.email1 }}</span>
          <span v-if="holderData.email">
            <i class="iconfont iconxianshi eye-icon" v-if="holderData.eyeShow3" @click="openEye(holderData, 'eyeShow3', 'email')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye(holderData, 'eyeShow3', 'email')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem label="所在地区">
        <span>{{ holderData.area }}</span>
      </FormItem>
      <FormItem label="详细地址">
        <div>
          <span v-if="!holderData.eyeShow4">{{ holderData.address }}</span>
          <span v-else>{{ holderData.address1 }}</span>
          <span v-if="holderData.address">
            <i class="iconfont iconxianshi eye-icon" v-if="holderData.eyeShow4" @click="openEye(holderData, 'eyeShow4', 'address')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye(holderData, 'eyeShow4', 'address')"></i>
          </span>
        </div>
      </FormItem>
      <div class="form-title">账户信息</div>
      <FormItem label="银行卡户名" prop="bankCardName">
        <div>{{ detailData.bankCardName | filterNull }}</div>
      </FormItem>
      <FormItem label="银行账户" prop="cardNo">
        <div>
          <span v-if="!detailData.eyeShow">{{ detailData.cardNo | filterNull }}</span>
          <span v-else>{{ detailData.cardNo1 | filterNull }}</span>
          <span v-if="detailData.cardNo">
            <i class="iconfont iconxianshi eye-icon" v-if="detailData.eyeShow" @click="openEye(detailData, 'eyeShow', 'cardNo')"></i>
            <i class="iconfont iconyincang eye-icon" v-else @click="openEye(detailData, 'eyeShow', 'cardNo')"></i>
          </span>
        </div>
      </FormItem>
      <FormItem label="开户行" prop="bank">
        <div>{{ detailData.bank | filterNull }}</div>
      </FormItem>
    </Form>
    <serviceAgentModal
      ref="serviceAgentModal"
      @success="
        getDetail();
        searchAjax();
      "
    ></serviceAgentModal>
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import filter from '@/api/filter';
import { pageTool, common } from '@/api/mixins';
import serviceAgentModal from './serviceAgentModal';
export default {
  components: { lzDicTxt, serviceAgentModal },
  mixins: [common, pageTool],
  props: ['detailData', 'formData'],
  data() {
    return {
      accountForm: {},
      columns: [
        {
          title: '服务代理人',
          slot: 'serviceAgent',
          align: 'center'
        },
        {
          title: '生效日期',
          key: 'serviceEffectiveDate',
          align: 'center',
          render(h, params) {
            const serviceEffectiveDate = params.row.serviceEffectiveDate && params.row.serviceEffectiveDate.substring(0, 10);
            return <span>{serviceEffectiveDate}</span>;
          }
        },
        {
          title: '操作时间',
          key: 'createTime',
          align: 'center',
          render(h, params) {
            const createTime = params.row.createTime && params.row.createTime.substring(0, 10);
            return <span>{createTime}</span>;
          }
        },
        {
          title: '操作人',
          key: 'operateName',
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ]
    };
  },
  watch: {
    'detailData.policyNo': {
      handler(val) {
        if (val) {
          this.searchParams.policyNo = this.detailData.policyNo;
          this.initListAjax('/buz/policyServiceChangeTask/read/list');
        }
      },
      immediate: true
    }
  },
  computed: {
    holderData() {
      if (this.detailData && this.detailData.holder) {
        return this.detailData.holder;
      }
      return {};
    }
  },
  methods: {
    openEye(item, keyName, name, index) {
      let operationType, otherInfo;
      otherInfo = {
        type: 1
      };
      if (name == 'mobile') {
        operationType = 2;
      } else if (name == 'cardNumber') {
        operationType = 1;
      } else if (name == 'address') {
        operationType = 5;
      } else if (name == 'email') {
        operationType = 4;
      } else if (name == 'cardNo') {
        operationType = 3;
      }
      if (!item[keyName]) {
        this.descrypt(
          {
            query: this.detailData.insureUniqueId,
            operationFunction: this.formData.operationFunction || 15,
            operationType: operationType,
            otherInfo: otherInfo
          },
          item,
          name + '1'
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
    // 删除
    deleteAgent(row) {
      this.$notice.inquiry(`是否确认删除？`).then(() => {
        this.$http({
          url: '/buz/policyServiceChangeTask/delete',
          type: 'GET',
          data: {
            id: row.id
          }
        }).then(res => {
          this.$notice.success('删除成功');
          this.searchAjax();
        });
      });
    },
    getDetail() {
      this.$emit('refresh');
    },
    changeServiceAgent() {
      this.$refs.serviceAgentModal.open(this.detailData);
    }
  },
  filters: {
    filterNull(val) {
      if (!val) {
        return '-';
      }
      return val;
    },
    filterPayType: filter.filterPayType,
    filterInsureOrderStatus: filter.filterInsureOrderStatus,
    filterSex: filter.filterSex,
    filterCardType: filter.filterCardType
  }
};
</script>
<style lang="scss" scoped>
.disabled {
  color: #c5c8ce !important;
}

.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;

  &.red {
    background: #e3461f !important;
  }
}

/deep/ .ivu-form-item-content {
  line-height: 32px !important;
}

/deep/ .ivu-form-item-label {
  font-size: 14px !important;
}

.btn-change {
  margin-left: 10px;
  height: 28px;
}
</style>
